import { useQueryClient } from 'react-query';
import moment from 'moment';
import { useCallback } from 'react';
import { CacheKeys } from '../constants';
import { useConversationUpdate } from './useConversationUpdate';
export const useLocalConversationUpdate = () => {
    const queryClient = useQueryClient();
    const updateConversation = useConversationUpdate();
    const mutate = useCallback(({ data, isFocused, visibility, user }) => {
        const conversation = queryClient.getQueryData([
            CacheKeys.CONVERSATION,
            data.id
        ]);
        const conversations = queryClient.getQueryData([CacheKeys.CONVERSATIONS, data.status]);
        const shouldUpdateRemote = isFocused && data.unseen[visibility] !== 0;
        const next = !shouldUpdateRemote
            ? data
            : Object.assign(Object.assign({}, data), { unseen: {
                    public: visibility === 'public' ? 0 : data.unseen.public,
                    private: visibility === 'private' ? 0 : data.unseen.private
                } });
        if (conversation) {
            queryClient.setQueryData([CacheKeys.CONVERSATION, data.id], next);
        }
        if (conversations) {
            queryClient.setQueryData([CacheKeys.CONVERSATIONS, data.status], Object.assign(Object.assign({}, conversations), { pages: conversations.pages.map((page) => (Object.assign(Object.assign({}, page), { records: page.records
                        .map((record) => (record.id === data.id ? next : record))
                        .sort((a, b) => moment(b.updatedAt).valueOf() - moment(a.updatedAt).valueOf()) }))) }));
        }
        if (shouldUpdateRemote) {
            updateConversation.mutate({
                id: data.id,
                user,
                unseen: next.unseen
            });
        }
    }, []);
    return { mutate };
};
//# sourceMappingURL=useLocalConversationUpdate.js.map